import { CloudMarketplace } from '../productsListing/types'

export enum DisbursementStatus {
  NOT_DISBURSED = 'INVOICED',
  DISBURSED = 'DISBURSED',
  DEFAULTED = 'Defaulted',
}

export enum OfferStatusType {
  PRIVATE = 'private',
  PUBLIC = 'public',
  ALL = 'All',
}

export enum PaymentStatus {
  DISBURSED = 'disbursed',
  NOT_DISBURSED = 'invoiced',
  DEFAULTERS = 'defaulters',
  ALL = 'All',
}

export enum OfferVisibilitySatus {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  CPPO = 'CPPO',
}

export enum DateRangesTypeStatus {
  ALL = 'All',
  THIRTY = '30',
  SIXTY = '60',
  NINETY = '90',
}

export enum revenueDateTypeOptionsMap {
  INVOICE = 'invoice_date',
  PAYMENT_DUE = 'payment_due_date',
  DISBURSED = 'disbursement_date',
}

export enum RevenueTrackingActionTypes {
  SET_REPORTS_DATA = 'SET_REPORTS_DATA',
  REVENUE_SET_PAGE_NUMBER = 'REVENUE_SET_PAGE_NUMBER',
  REVENUE_SET_LIMIT = 'REVENUE_SET_LIMIT',
  SET_PRODUCT_ID = 'SET_PRODUCT_ID',
  CLEAR_REVENUE_REPORTS = 'CLEAR_REVENUE_REPORTS',
  SET_DATE_RANGE = 'SET_DATE_RANGE',
  SET_DATE_RANGE_TYPE = 'SET_DATE_RANGE_TYPE',
  SET_FILTERS = 'SET_FILTERS',
  CLEAR_REVENUE_FILTERS = 'CLEAR_REVENUE_FILTERS',
}

export const disbursementStatusMap = {
  'Not disbursed': DisbursementStatus.NOT_DISBURSED,
  Disbursed: DisbursementStatus.DISBURSED,
  Defaulted: DisbursementStatus.DEFAULTED,
}

export type OfferType = 'PUBLIC' | 'PRIVATE'

export interface GraphData {
  date: string
  totalAmountActivated?: number
  totalAmountBilled?: number
  totalAmountDisbursed?: number
}

export interface DateRange {
  startDate: string
  endDate: string
}

export interface FiltersState {
  paymentStatus: string
  offerType: string
  disbursementDate: string
  paymentDueDate: string
  paymentDelayedSince: string
}

export interface ReportsRow {
  updatedAt: string
  invoiceId: string
  disbursementBillingEventId: string
  invoiceDate: string
  date: string
  productTitle: string
  labraProductId: string
  cloudMarketplaceProductCode: string
  labraBuyerName: string
  buyerId: string
  labraBuyerLogoUrl: string
  subscriberAWSAccountId: string
  activatedAmount?: string
  billedAmount?: string
  revenue?: string
  deductions?: string
  listingFeeRefund?: string
  disbursedAmount?: string
  netRevenue?: string
  paymentDueDate?: string
  disbursementStatus?: DisbursementStatus
  disbursementDate?: string
  paymentTerms?: string
  offerType?: OfferType
  agreementId?: string
  subscriberName?: string
  offerVisibility?: string
  bankTraceId?: string
  awsRevShare?: string
  awsTaxShare?: string
  awsTaxShareRefund?: string
  sellerRevShare?: string
  sellerTaxShare?: string
  sellerTaxRefund?: string
  sellerCompanyName?: string
  LabraSellerLogoUrl?: string
  awsTaxShareListingFee?: string
  awsTaxShareRefundListingFee?: string
  resellerName?: string
  resellerAWSAccountId?: string
  resellerAccountId?: string
  agreementAcceptanceDate?: string
  agreementStartDate?: string
  agreementEndDate?: string
  transactionReferenceId?: string
  brokerId?: string
  buyerCompanyName?: string
  postalCode?: string
  buyerEmailDomain?: string
  buyerCity?: string
  buyerStateOrRegion?: string
  buyerPostalCode?: string
  buyerCountryCode?: string
  buyerAddressId?: string
  buyerEmailAddress?: string
  privateOfferName?: string
  listingFeePercentage?: string
  listingFee?: string
  currency?: string
  grossRefund?: string
  grossAmount?: string
  wholeSaleCost?: string
  wholeSaleCostRefund?: string
  sellerNetRevenue?: string
  resaleAuthorizationId?: string
  resaleAuthorizationName?: string
  resellerCompanyName?: string
  payerCompanyName?: string
  payerAwsAccountId?: string
  payerEmailDomain?: string
  payerCity?: string
  payerStateOrRegion?: string
  payerCountryCode?: string
  payerPostalCode?: string
  payerAccountId?: string
  payerAddressId?: string
  payerEncryptedAccountId?: string
  listingFeeInvoiceId?: string
  wholesaleInvoiceId?: string
  wholesaleSellerTaxShare?: string
  wholesaleSellerTaxShareRefund?: string
  wholesaleOtherSellerTaxShare?: string
  wholesaleOtherSellerTaxShareRefund?: string
  wholesaleAwsTaxShare?: string
  wholesaleAwsTaxShareRefund?: string
  disbursedNetRevenue?: string
  undisbursedNetRevenue?: string
  collectedNetRevenue?: string
  uncollectedNetRevenue?: string
  lastCollectionDate?: string
  buyerAwsAccountId?: string
  awsOfferId?: string
  cloudOfferId?: string
  cloudBuyerAccountId?: string
  awsSorId?: string
  resaleAuthorizationDescription?: string
  billingAccountId?: string
  planName?: string
  itemId?: string
  externalRecordId?: string
  labraSubscriptionId?: string
  feedType?: string
  companyName?: string
  grossRevenue?: string
  offerId?: string
  accountId?: string
  emailDomain?: string
  state?: string
  country?: string
  offerName?: string
  contractId?: string
  contractStartDate?: string
  contractAcceptanceDate?: string
  contractEndDate?: string
  usagePeriodStartDate?: string
  usagePeriodEndDate?: string
  payoutEntity?: string
}

export interface LastEvaluatedObject {
  [key: string]: string
}

export interface InsertDates {
  [key: string]: string
}

export interface ReportsData {
  records: ReportsRow[]
  totalAmountActivated?: string
  amountChange?: string
  percentageChange?: string
  totalAmountBilled?: string
  totalAmountDisbursed?: string
  pageSize: number
  pageNumber: number
  noOfPage: number | null
  graphData: GraphData[]
  dateRange: DateRange
  dateRangeType?: string
  filters: FiltersState
  lastEvaluatedObject?: LastEvaluatedObject | null
  count?: number
  tcv?: number
  insertDates?: InsertDates
}

export interface ReportsPayload {
  records: ReportsRow[]
  insertDates?: InsertDates
  totalAmountActivated?: string
  totalAmountBilled?: string
  totalAmountDisbursed?: string
  count: number
  pageSize: number
  cloudMarketplace: CloudMarketplace
}

export type RevenueInsightsAction =
  | {
      type: RevenueTrackingActionTypes.SET_REPORTS_DATA
      payload: ReportsPayload
    }
  | {
      type: RevenueTrackingActionTypes.REVENUE_SET_PAGE_NUMBER
      payload: number
    }
  | {
      type: RevenueTrackingActionTypes.REVENUE_SET_LIMIT
      payload: number
    }
  | {
      type: RevenueTrackingActionTypes.CLEAR_REVENUE_REPORTS
    }
  | {
      type: RevenueTrackingActionTypes.SET_DATE_RANGE
      payload: DateRange
    }
  | { type: RevenueTrackingActionTypes.SET_DATE_RANGE_TYPE; payload: string }
  | { type: RevenueTrackingActionTypes.SET_FILTERS; payload: FiltersState }
  | { type: RevenueTrackingActionTypes.CLEAR_REVENUE_FILTERS }

export const initialFilterRevenueState: FiltersState = {
  paymentStatus: PaymentStatus.ALL,
  offerType: OfferStatusType.ALL,
  disbursementDate: DateRangesTypeStatus.ALL,
  paymentDueDate: DateRangesTypeStatus.ALL,
  paymentDelayedSince: DateRangesTypeStatus.ALL,
}
